import * as React from 'react';

import { clsx } from 'clsx';
import * as style from './style.css';

interface IPhoneLinkWrapperProps {
  phone: React.ReactNode;
  qr: React.ReactNode;
  builder: React.ReactNode;
}

export const PhoneLinkWrapper = ({ phone, qr, builder }: IPhoneLinkWrapperProps): React.JSX.Element => {
  return (
    <div className={clsx(style['wrapper'], !builder && style['wrapper--gap'])} data-testid="DynamicPhoneLink">
      <div className={style['phone']}>
        {phone}
        <div className={style['builder']}>{builder}</div>
      </div>
      {qr}
    </div>
  );
};
